import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
export function WhoWeAre() {
  return <section id="quienes-somos" className="w-full bg-vm-navy py-28 lg:py-36" data-id="element-176" data-mp="2u79k61cs07b">
      <div className="max-w-7xl mx-auto px-6 lg:px-10" data-id="element-177" data-mp="gmn4sko0itxo">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-16" data-id="element-178" data-mp="go7xe4qro2sw">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-7" data-id="element-179" data-mp="clbnd2falf0k">
            <SectionLabel data-id="element-180" data-mp="3u1t6zgxhb6fq">Quiénes somos</SectionLabel>
            <h2 className="mt-6 max-w-3xl font-syne text-4xl font-bold leading-[1.03] text-white sm:text-5xl lg:text-[56px]" data-id="element-181" data-mp="3u2l08l3lss2u">
              Tecnología visual para proyectos que necesitan ser vistos.
            </h2>
            <div className="mt-8 max-w-2xl space-y-5 text-lg font-light leading-relaxed text-vm-muted" data-id="element-182" data-mp="19cvrmpthu2il">
              <p data-id="element-183" data-mp="1404bwremh393">
                Vivo Media es una empresa de tecnología visual y soluciones audiovisuales orientada a clientes corporativos y al mundo del deporte: ligas, clubes y canales de transmisión.
              </p>
              <p data-id="element-184" data-mp="1d0ang7qrft5m">
                Combinamos hardware —pantallas LED—, producción —streaming y fotografía— y diseño —gráfica y señalética— en una misma propuesta, para resolver cada experiencia con una mirada integral.
              </p>
            </div>
          </motion.div>

          <motion.aside initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="border-l-2 border-vm-electric pl-6 sm:pl-8 lg:col-span-5 lg:mt-12" data-id="element-185" data-mp="pb7va5yi2hwv">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-vm-electric" data-id="element-186" data-mp="1mf6quk7jcca">En movimiento</p>
            <p className="mt-4 max-w-sm text-xl font-light leading-relaxed text-white sm:text-2xl" data-id="element-187" data-mp="6jos9z4h73uu">
              Una marca establecida que construye una presencia digital e identidad propia desde cero.
            </p>
            <p className="mt-5 max-w-sm leading-relaxed text-vm-muted" data-id="element-188" data-mp="3qnbkt5xww147">
              Nuestro enfoque es independiente y está diseñado para crecer junto a cada proyecto, equipo y audiencia.
            </p>
          </motion.aside>
        </div>
      </div>
    </section>;
}